import type { Client } from 'models/flexible/Client';
import type { Group } from 'models/flexible/Group';

import { AICriteria, AICriteriaCategory, type AICriteriaCategoryOptions, type AICriteriaOptions } from './AICriteria';

export interface AICriteriaSetOptions {
  id?: string;
  type?: string;
  scopeableType?: string;
  scopeableId?: string;
  archived?: boolean;
  createdAt?: string;
  updatedAt?: string;
  group?: any;
  client?: any;
  criteria?: AICriteriaOptions[];
  categories?: AICriteriaCategoryOptions[];
  inheritedCriteria?: AICriteriaOptions[];
  inheritedCategories?: AICriteriaCategoryOptions[];
  // Wire key is `hiddenAICriteriaIds` (capital AI) — OliveBranch camelizes `hidden_ai_criteria_ids`
  // using the app's `AI` acronym inflection, not a naive camelize.
  hiddenAICriteriaIds?: string[];
}

export class AICriteriaSet {
  id: string;
  type: string;
  scopeableType: string;
  scopeableId: string;
  archived: boolean;
  createdAt: Date | null;
  updatedAt: Date | null;
  group?: Group;
  client?: Client;
  criteria: AICriteria[];
  categories: AICriteriaCategory[];
  inheritedCriteria: AICriteria[];
  inheritedCategories: AICriteriaCategory[];
  hiddenAiCriteriaIds: string[];

  constructor(options?: AICriteriaSetOptions) {
    this.id = options?.id ?? '';
    this.type = options?.type ?? '';
    this.scopeableType = options?.scopeableType ?? '';
    this.scopeableId = options?.scopeableId ?? '';
    this.archived = options?.archived ?? false;
    this.createdAt = options?.createdAt ? new Date(options.createdAt) : null;
    this.updatedAt = options?.updatedAt ? new Date(options.updatedAt) : null;
    this.group = options?.group;
    this.client = options?.client;
    this.criteria = (options?.criteria ?? []).map((c) => new AICriteria(c));
    this.categories = (options?.categories ?? []).map((c) => new AICriteriaCategory(c));
    this.inheritedCriteria = (options?.inheritedCriteria ?? []).map((c) => new AICriteria(c));
    this.inheritedCategories = (options?.inheritedCategories ?? []).map((c) => new AICriteriaCategory(c));
    this.hiddenAiCriteriaIds = options?.hiddenAICriteriaIds ?? [];
  }
}
